module.exports = __webpack_public_path__ + "img/OrgChartTemp2.02eca5b1.png";